<div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px">
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters"
                   (selectedItemsChanged)="onSelectedItemsChanged($event)"
                   [selectedItemsChange]="selectedFilterChange"
                   [showFilterButton]="true" (onFilterButtonClicked)="showFilterDialog()"
                   [showDateRange]="true" [defaultDateRange]="2"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
  </app-grid-filter>
  <div fxFlex class="stretched-container">
    <app-audit-grid [filterChangeEvent]="filterChangeEvent" [auditTypes]="auditTypes" [auditCategories]="auditCategories" [auditUsers]="auditUsers"></app-audit-grid>
  </div>
</div>
